<template>
    <div class="container block_screen">
        <div class="">
            <div class="first_page">
                <div class="container--small">
                    <i class="icon-Product-Icon_HDM_Suite main-icon f-blue"></i>
                    <p class="promo-text">
                        Welcome to
                    </p>
                    <h1>Paragon Hard Disk Manager (HDM)</h1>
                    <p class="desc">
                        It's all-in-one data management software that helps you arrange, allocate and protect data on
                        your hard drive.
                        As such, it lets you perform multiple actions:
                    </p>
                    <ul class="hdm_list">
                        <li><a data-name="Backup/restore" @click.prevent="changeScreen(90)" class="tellus gotolast"
                               href="#">Backup/restore</a></li>
                        <li><a data-name="Manage partitions" class="tellus gotolast" href="#" @click.prevent="changeScreen(30)">Manage partitions</a></li>
                        <li><a data-name="Migrate data/OS" @click.prevent="changeScreen(53)" class="tellus gotolast" href="#">Migrate data/OS</a></li>
                        <li><a data-name="Wipe/sanitize data" @click.prevent="changeScreen(65)" class="tellus gotolast" href="#">Wipe/sanitize data</a></li>
                        <li><a data-name="Create a disk image" @click.prevent="changeScreen(76)" class="tellus gotolast" href="#">Create a disk image</a></li>
                    </ul>
                    <p class="desc">
                        Pick your scenario and see how it works in HDM!
                    </p>
                    <div class="btn_right">
                        <a data-name="skip" href="" @click.prevent="changeScreen(100)"
                           class="btn btn_orange">Skip</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import {mapMutations} from 'vuex'
  export default {
    methods: {
      ...mapMutations({
        changeScreen: 'setScreen' // map `this.add()` to `this.$store.commit('increment')`
      })
    },
  };
</script>
